import React from 'react';
import { useNavigate } from 'react-router-dom';
import { surveySteps } from "../Questions/Questions";
import updateUserProgress from './updateUserProgress';
import { db } from '../../../utils/firebase-config';
import { doc, updateDoc } from "firebase/firestore";

const AreaNavigator = ({ setCurrentStep, userId, progress, destination }) => {
  const navigate = useNavigate();

  const handleJumpToArea = async (area, destination) => {
    const savedStep = progress[area] || 0;
    setCurrentStep(savedStep);
    await updateUserProgress(userId, area, savedStep); // Save the current step for the new area
    const userDocRef = doc(db, 'users', userId);
    await updateDoc(userDocRef, { currentStep: savedStep });
    navigate(`/survey/${savedStep}`);
  };

  return (
    <div>
      <button  className="mt-2 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors" onClick={() => handleJumpToArea(destination)}>Go to {destination}</button>
      {/* <button  className="mt-2 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors" onClick={() => handleJumpToArea('Entrepreneurship & Philanthropy')}>Go to Entrepreneurship & Philanthropy</button> */}
    </div>
  );
};

export default AreaNavigator;
